// Centralized config: replace WHOP_URL with the live Whop checkout link when ready.
export const WHOP_URL = "https://whop.com/checkout/plan_FNo2yyUqQme6F";

export const PRICE = {
    original: "€49.96",
    discounted: "€11.99",
    discountLabel: "76% OFF",
};

export const ASSETS = {
    viktor: "https://customer-assets.emergentagent.com/job_86b0245b-7dca-4a12-a304-9d7cff8573ef/artifacts/wibi9uyo_banner.png",
    book: "https://customer-assets.emergentagent.com/job_86b0245b-7dca-4a12-a304-9d7cff8573ef/artifacts/umhqqwyr_shopify%20headl.png",
    seal: "https://static.prod-images.emergentagent.com/jobs/86b0245b-7dca-4a12-a304-9d7cff8573ef/images/83a552c6b32e72ccf75ab50df1ec8a7c03ff7df58bbbdb91f4aa42cd489901c4.png",
};

export const PHASES = [
    {
        roman: "I",
        title: "The Funeral of Your Former Self",
        teaser:
            "Interrupt the automatic loops that made you predictable. Bury the man who could be controlled.",
        bullets: [
            "Deconstruct learned responses",
            "Break inherited weakness",
            "Reset the operating system",
        ],
    },
    {
        roman: "II",
        title: "The Forging of the New Identity",
        teaser:
            "Identity is not discovered. It is installed — through repetition, standards, and non-negotiables.",
        bullets: [
            "Behavioral frameworks",
            "Non-negotiable standards",
            "The new internal contract",
        ],
    },
    {
        roman: "III",
        title: "The Game of Perception & Power",
        teaser:
            "Reality is not what exists — it is what is perceived. Control frames, project status, weaponize language.",
        bullets: [
            "Frame control",
            "Status projection",
            "Strategic language",
        ],
    },
    {
        roman: "IV",
        title: "Social Dominance & Strategic Relationships",
        teaser:
            "Power is amplified through people — but only if you own the dynamic. Enter every room as the variable they account for.",
        bullets: [
            "Reading hierarchy",
            "Engineered presence",
            "Desire, respect, control",
        ],
    },
    {
        roman: "V",
        title: "The External Manifestation",
        teaser:
            "Your inner structure must show on the outside. Style, body, territory — designed to multiply opportunity.",
        bullets: [
            "The aesthetic of power",
            "The body as a weapon",
            "Engineered territory",
        ],
    },
];

export const PRINCIPLES = [
    "Human behavior is programmable.",
    "Discomfort is a signal of expansion, not danger.",
    "Identity is constructed through repetition, not discovered.",
    "Standards — not goals — define your baseline.",
    "Control of perception is achieved through frame control.",
    "Status is assigned, not given. It is built through behavior.",
    "Scarcity of your time and attention raises your value.",
    "Desire and respect are created by withholding predictability.",
    "Environment shapes behavior faster than effort.",
    "Money is a tool for control, not an identity.",
    "Leverage — not activity — leads to freedom.",
    "Consistency in non-negotiables creates the man.",
];

export const TESTIMONIALS = [
    {
        quote:
            "I read it twice in 48 hours. The frame control chapter alone changed three negotiations that week.",
        name: "M. Castellanos",
        meta: "Founder, private equity",
    },
    {
        quote:
            "Most ‘power’ books are noise. This is operational. Cold, precise, almost surgical.",
        name: "D. Renard",
        meta: "Former military, now CEO",
    },
    {
        quote:
            "Phase II broke me. Then it rebuilt me into someone people stop talking to when I enter the room.",
        name: "A. Volkov",
        meta: "Anonymous reader",
    },
    {
        quote:
            "Worth a hundred times what I paid. I would not let a competitor of mine read this.",
        name: "S. Marchetti",
        meta: "Real estate, Milan",
    },
];

export const FAQ = [
    {
        q: "Is this another generic self-help book?",
        a: "No. The Varek Code is a behavioral system — phases, frameworks, and non-negotiable standards. It is engineered to be applied within 72 hours of reading, not motivational reading.",
    },
    {
        q: "Why is it €11.99 when the value is €49.96?",
        a: "The launch window is intentionally aggressive. Once a critical mass of operators has the system in their hands, the price returns to €49.96. There is no second discount.",
    },
    {
        q: "How is the book delivered?",
        a: "Instant digital delivery after checkout. You receive it within seconds of payment.",
    },
    {
        q: "Will this actually change me?",
        a: "Only if you execute it. The people who apply the systems inside usually notice changes in confidence, presence, discipline, communication, and social positioning within days.",
    },
    {
        q: "Who is this made for?",
        a: "People tired of feeling average, invisible, reactive, weak, or mentally undisciplined. If you want more respect, stronger presence, and control over yourself and your environment, this was built for you.",
    },
    {
        q: "Will this work if I am 'introverted' or 'shy'?",
        a: "Yes. The Code does not require performance. It restructures how others read you — even when you say nothing. Frame and presence are mechanical, not personality-based.",
    },
    {
        q: "Is there a refund policy?",
        a: "Digital final-sale. Read the table of contents and the manifesto on this page. If the Code is not for you, do not buy it. This is a filter, not a funnel.",
    },
    {
        q: "Who is Viktor Varek?",
        a: "A private figure who spent years inside environments where weakness was punished and observation was survival. The Code is the distilled record of what he learned to stop being prey.",
    },
];
